/** Page title row — the same shape every TaskManagement page opens with. */
import type { ReactNode } from 'react';
import { Group, Stack, Title, Text } from '@/components/ui';

export function PageHeader({ title, subtitle, actions }: { title: string; subtitle?: ReactNode; actions?: ReactNode }) {
  return (
    <Group justify="space-between" wrap="wrap" align="flex-start">
      <Stack gap={0}>
        <Title order={2}>{title}</Title>
        {subtitle && <Text c="dimmed" size="sm">{subtitle}</Text>}
      </Stack>
      {actions && <Group gap="sm">{actions}</Group>}
    </Group>
  );
}
